import { global } from ":shared/app";

export type GET = {
  returns: {
    id: number;
    image: string;
    title: string;
    description: string;
    category: string;
    track: string;
    link: string;
  }[];
};
export const endpoint = "resources/";
export async function get(): Promise<GET["returns"]> {
  // return Promise.resolve(import("./resources.mocks")).then((r) => {
  //   return r.success;
  // });
  return global.api
    .getAuth(endpoint)
    .then((res) => {
      let res_list = res.data as GET["returns"];
      res_list = res_list.sort((a, b) => b.id - a.id);
      return Promise.resolve(res_list);
    })
    .catch((err) => {
      // message: service.api.decode_error(err, "couldn't update password"),
      return Promise.reject(err.message);
    });
}
